module.exports = __webpack_public_path__ + "static/media/5.f664b8ac.jpg";